<div class="bank-details-container">

    <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
        <div class="field md:col-4 col-12">
            <!-- <label [style]="{color: 'rgb(168, 32, 32)'}">{{ 'Select Contractor' }}</label> -->
            <div class="grid-item">
                <p-dropdown [options]="contractorList" [(ngModel)]="selectedContractor"
                    (onChange)="onSelectContractor()" appendTo="body" placeholder="{{ 'Select Contractor'| translate }}"
                    optionLabel="ContractorName"></p-dropdown>
            </div>
        </div>
    </div>

    <!-- Visible on Small screens -->
    <!-- <div class="block md:hidden">
        <div *ngIf="loading">
            <div id="pause" class="flex align-items-center justify-content-center">
                <div id="spinner"></div>
            </div>
        </div>
        <div class="landing">
            <div class="header-container">
                <div class="icon">
                </div>
                <div class="header">
                    <p>{{'WELOCOME_TO'| translate}}</p>
                    <p>{{'MICADA_MOBILE_APPLICATION'| translate}}</p>
                </div>
                <div class="subheader">
                    <p> {{'EFFICIENT_AND_ELEGANT_WAY_TO_VERIFY_SITE'| translate}}</p>
                </div>
            </div>
        </div>
        <div style="padding: 0 1em;">
            <p-toolbar styleClass="mb-4" reflow="true">
                <ng-template pTemplate="left"></ng-template>
                <ng-template pTemplate="right">
                    <button *ngIf="mobileFarmerUHBVNpvData.length > 0" (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                        class="p-button-help"></button>
                        <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                                  class="p-button-info ml-3"></button>
                    <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                </ng-template>
                   </p-toolbar>
            <p-card class="mobile-card"> <div class="mobile_search">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="mobileSearch($any($event.target).value)"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
            </div></p-card>
            <p-card styleClass="p-card-shadow my-2 widthFull" *ngFor="let item of mobileFarmerUHBVNpvData"
                (click)="selectPreSurveyData(item)" [style]="{'color': 'black', 'background-color': rowBackgroundColor(item)}">
                <table cellspacing="10">
                    <tr>
                        <td class="fontXl"><b>{{'APP_ID'| translate}}</b></td>
                        <td class="fontXl"><b>{{item.AppId}}</b>
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'FARMER_NAME'| translate}}</b></td>
                        <td>
                            {{item.Farmer_Name}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'MOBILE_NO'| translate}}</b></td>
                        <td>
                            {{item.FarmerMobile}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'FATHERS_NAME'| translate}}</b></td>
                        <td>
                            {{item.Father_Name}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'VILLAGE'| translate}}</b></td>
                        <td>
                            {{item.VillageName}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'VENDOR_NAME'| translate}}</b></td>
                        <td>
                            {{item.VendorFullName}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'PROGRAMME_NAME'| translate}}</b></td>
                        <td>
                            {{item.Program_Name}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'KILLA_NO'| translate}}</b></td>
                        <td>
                            {{item.KillaNo}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'TOTAL_AREA_IN_ACRE'| translate}}</b></td>
                        <td>
                            {{item.AreaAcre}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'FINANCIAL_YEAR'| translate}}</b></td>
                        <td>
                            {{item.Fin_Year}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'Status'| translate}}</b></td>
                        <td>
                            {{item.JE_Status}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'ESTIMATION_ACTION'| translate}}</b></td>
                        <td  *ngIf="!(isJeLogin && item?.JE_Status == 'Approved' || isXenLogin && item?.XEN_Status == 'Done')">
                            <button pButton pRipple type="button" pTooltip="Add-Estimation" icon="pi pi-plus"
                                class="p-button-rounded p-button-text" (click)="addEstimation(item)"></button>
                        </td>
                        <td  *ngIf="(isJeLogin && item?.JE_Status == 'Approved' || isXenLogin && item?.XEN_Status == 'Done')">
                            <button pButton pRipple type="button" pTooltip="Edit-Estimation"
                                (click)="updateEstimation(item)" icon="pi pi-pencil"
                                class="p-button-rounded p-button-text"></button>
                        </td>
                    </tr>
                </table>
            </p-card>
        </div>
    </div> -->

    <!-- <div class="grid hidden md:block mt-2"> -->
    <div *ngIf="showDetailTable" class="grid">
        <div class="col-12">
            <div class="card">
                <div class="dashboardTable">
                    <p-table #epcPVDoneTable [value]="epvPVDoneData" dataKey="id" [rows]="10" [paginator]="true"
                        [globalFilterFields]="[
                        'APP_ID',
                        'Name',
                        'Father_name',
                        'Mobile',
                        'ContractorName',
                        'Outlets',
                        'AgreementNo',
                        'ProposedSystem',
                        'TotalArea',
                        'Village',
                        'District',
                        'Block',
                        'XEN_Remarks', 
                        'XEN_Status', 
                        'JE_Remarks', 
                        'JE_Status', 
                        'JEID',
                        ]" responsiveLayout="scroll" [rowHover]="true" sortMode="multiple"
                        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                        [showCurrentPageReport]="true" [loading]="loading">
                        <ng-template pTemplate="caption">
                            <div class="flex align-items-center justify-content-between">
                                <!-- Left side -->
                                <div class="col-5">
                                    <h5 class="m-0 table-header-text">{{'Application for Approval'| translate}}</h5>
                                </div>
                                <!-- Middle section for buttons -->
                                <div class="col-4 d-flex  justify-content-between">
                                    <button *ngIf="epvPVDoneData.length > 0" (click)="menu.toggle($event)" pButton
                                        pRipple label="" icon="pi pi-download" class="p-button-help mx-1"></button>
                                    <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh"
                                        class="p-button-info mx-1"></button>
                                    <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                                </div>
                                <!-- Right side for search -->
                                <div class="col-3 d-flex align-items-center justify-content-end">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input pInputText type="text"
                                            (input)="epcPVDoneTable.filterGlobal($any($event.target).value, 'contains')"
                                            placeholder="{{'SEARCH'| translate}}" />
                                    </span>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="APP_ID">{{'APP_ID'| translate}}</th>
                                <th>{{'TOTAL_AREA_ACRE'| translate}}</th>
                                <th>{{'FARMER_NAME'| translate}}</th>
                                <th>{{'FATHERS_NAME'| translate}}</th>
                                <th>{{'MOBILE_NO'| translate}}</th>
                                <th>{{'CONTRACTOR_NAME'| translate}}</th>
                                <th>{{'OUTLET'| translate}}</th>
                                <th>{{'AGREEMENT_NO'| translate}}</th>
                                <th>{{'PROGRAMME_NAME'| translate}}</th>
                                <th>{{'TOTAL_AREA'| translate}}</th>
                                <th>{{'DISTRICT'| translate}}</th>
                                <th>{{'VILLAGE'| translate}}</th>
                                <th>{{'BLOCK'| translate}}</th>
                                <th>{{'XEN_STATUS'| translate}}</th>
                                <th>{{'XEN_REMARKS'| translate}}</th>
                                <th>{{'JE_ID'| translate}}</th>
                                <th>{{'JE_STATUS'| translate}}</th>
                                <th>{{'JE_REMARKS'| translate}}</th>
                                <th>{{'ACTION'| translate}}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product>
                            <tr [style]="{'background-color': (product.ReVerificationStatus == 'Approved')  ? 'rgb(200, 246, 221)' : 'rgb(249, 212, 212)'}">
                                <td>{{product.APP_ID}}</td>
                                <td>{{product.TotalArea}}</td>
                                <td>{{product.Name}}</td>
                                <td>{{product.Father_name}}</td>
                                <td>{{product.Mobile}}</td>
                                <td>{{product.ContractorName}}</td>
                                <td>{{product.Outlets}}</td>
                                <td>{{product.AgreementNo}}</td>
                                <td>{{product.ProposedSystem}}</td>
                                <td>{{product.TotalArea}}</td>
                                <td>{{product.District}}</td>
                                <td>{{product.Block}}</td>
                                <td>{{product.Village}}</td>
                                <td>{{product.XEN_Status}}</td>
                                <td>{{product.XEN_Remarks}}</td>
                                <td>{{product.JEID}}</td>
                                <td>{{product.JE_Status}}</td>
                                <td>{{product.JE_Remarks}}</td>
                                <!-- <td><button pButton pRipple pTooltip="view application" icon="pi pi-file"
                                    class="p-button-rounded p-button-accent mr-1 btnSize"
                                    (click)="selectViewApplication(product,product?.Status_Ar)"></button></td> -->
                                <td>
                                    <button *ngIf="product.ReVerificationStatus != 'Approved'" pButton pRipple type="button" pTooltip="" icon="pi pi-plus"
                                        class="p-button-rounded p-button-text"
                                        (click)="onClickAppAction(product)"></button>
                                    <!-- <button
                                        *ngIf="(isJeLogin && product?.JE_Status == 'Approved' || isXenLogin && product?.XEN_Status == 'Done')"
                                        pButton pRipple type="button" pTooltip="" (click)="updateEstimation(product)"
                                        icon="pi pi-pencil" class="p-button-rounded p-button-text"></button> -->
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <div class="flex  justify-content-between flex-column ">
                                <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{epvPVDoneData ? epvPVDoneData.length : 0 }}
                                    {{'for Approval'| translate}}.
                                </p>
                                <div class="flex  justify-content-between flex-column ">
                                    <div class="flex">
                                        <div
                                            style="background-color:#b9ecb9 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                        </div>{{'Approved'| translate}}
                                    </div>
                                    <div class="flex">
                                        <div
                                            style="background-color:#f9cece ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                        </div>{{'Not Approved'| translate}}
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="flex align-items-center justify-content-between">
                                {{'IN_TOTAL_THERE_ARE'| translate}} {{epvPVDoneData ?
                                epvPVDoneData.length : 0 }} {{'FARMER_PRE_SURVEY_ADDED'| translate}}.
                            </div> -->
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="7">No Data found.</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </div>
</div>

<p-dialog header="Farmer Land Details" [baseZIndex]="-100" [(visible)]="showActionDialog" [modal]="true"
    [style]="{width: '85%',height:'100%'}" [maximizable]="true" [draggable]="false" [resizable]="false"
    (onHide)="onCloseActionDialog()">
    <!-- <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
        <div class="field md:col-4 col-12">
            <label>{{'APP_ID'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{
                    programmeAppId}}</label></label>
        </div>

        <div class="field md:col-4 col-12">
            <label>{{'FARMER_NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ programmeFarmerName |
                    uppercase}}</label></label>
        </div>
        <div class="field md:col-4 col-12">
            <label>{{'PROG_NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ programName |
                    uppercase}}</label></label>
        </div>
    </div> -->

    <div class="card">
        <h6 [style]="{'font-weight': 'bold', 'color': 'black'}">{{'LAND_DETAILS' | translate}}</h6>
        <div *ngIf="epcDataForAppLandDetails && epcDataForAppLandDetails.length > 0" class="dashboardTable">
            <p-table [value]="epcDataForAppLandDetails" [rows]="8" showGridlines [tableStyle]="{ 'width': '30%' }"
                responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{'KILLA_NO' | translate}}</th>
                        <th>{{'MORABBA_NO'| translate}}</th>
                        <th>{{'LAND_DOC'| translate}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                    <tr>
                        <td class="surveyEstimateTable">{{product.Killa_No}}</td>
                        <td class="surveyEstimateTable">{{product.Morabba_No}}</td>
                        <td>
                            <a style="cursor: pointer" icon="pi pi-eye" [href]="product?.Land_Doc" target="_blank">
                                <button pButton type="button"
                                    class="p-button-rounded p-button-accent p-button-secondary p-button-rounded"
                                    pTooltip="{{ 'VIEW' | translate }}" icon="pi pi-eye"></button>
                            </a>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <div class="gps-coordinate-container">
        <div class="card">
            <h5>{{'CAPTURE_GPS_COORDINATES' | translate}}</h5>
            <div *ngIf="geoLocMulArray && geoLocMulArray.length>0 || overlays.length>0" class="dashboardTable">
                <ng-container *ngFor="let array of geoLocMulArray; let i = index">
                    <p-table [value]="array" [rows]="8" showGridlines [tableStyle]="{ 'width': '30%' }"
                        responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                        <ng-template pTemplate="caption">
                            <p>Table {{ i + 1}}</p>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th>{{'CORNER_ID' | translate}}</th>
                                <th>{{'LATITUDE'| translate}}</th>
                                <th>{{'LONGITUDE'| translate}}</th>
                                <!-- <th *ngIf="geoLocMulArray.length - 1 == i">{{'ACTIONS'| translate}}</th> -->
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                            <tr>
                                <td class="surveyEstimateTable">{{product.CornerID}}</td>
                                <td class="surveyEstimateTable">{{product.lat}}</td>
                                <td class="surveyEstimateTable">{{product.lng}}</td>
                                <!-- <td class="surveyEstimateTable">
                                    <button *ngIf="geoLocMulArray.length - 1 == i" pButton pRipple type="button" icon="pi pi-times" (click)="onDeleteCoordinate(rowIndex, i)"
                                        class="p-button-rounded p-button-text p-button-danger"></button>
                                </td> -->
                            </tr>
                        </ng-template>
                        <!-- <ng-template pTemplate="summary">
                            <button *ngIf="geoLocMulArray.length - 1 == i" pButton pRipple type="submit" (click)="onCapture(i)" label="{{'CAPTURE_GPS_COORDINATES' | translate}}"
                                class="p-button-info mr-2 mb-2"></button>
                            <button *ngIf="geoLocMulArray.length != 1" pButton pRipple type="submit" (click)="onDeleteNewPolygon(i)" label="{{'Delete Polygon' | translate}}"
                                class="p-button-danger mr-2 mb-2"></button>

                            <button *ngIf="geoLocMulArray.length - 1 == i && geoLocMulArray[i].length >= 4" pButton pRipple type="submit" (click)="onStartNewPolygon(i)" label="{{'Create New Polygon' | translate}}"
                                class="p-button-warning mr-2 mb-2"></button>
                        </ng-template> -->
                    </p-table>
                </ng-container>
                <!-- <p-gmap *ngIf="mapEnable" #gmap [style]="{'height':'300px', 'margin-bottom': '1em'}" [options]="options"
                    [overlays]="overlays"></p-gmap> -->
                <p-gmap *ngIf="mapEnable" #gmap [style]="{'height':'300px', 'margin-bottom': '1em'}" [options]="options"
                    [overlays]="overlays"></p-gmap>

            </div>
            <div class="my-2 proDataButton flex justify-content-center">
                <p class="invalid-feedback" *ngIf="geolocationsarray && geolocationsarray.length<4 && coordinateError">{{coordinateError | translate}}</p>
                <!-- <button pButton pRipple type="submit" (click)="onCapture()" label="{{'CAPTURE_GPS_COORDINATES' | translate}}"
                    class="p-button-info mr-2 mb-2"></button> -->
                <!-- <button pButton pRipple type="submit" (click)="onRefreshCurrentLocation()" label="{{'REFRESH_CURRENT_GPS_COORDINATES' | translate}}"
                    class="p-button-secondary mr-2 mb-2"></button> -->
            </div>

        </div>
        <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
            <div class="field md:col-4 col-12 area-display-card">
                <label>{{'APPLIED_LAND_AREA_(ACRES)'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{surveyArea}}</label></label>
            </div>
            <div *ngIf="landArea > 0" class="field md:col-4 col-12 area-display-card">
                <label>{{'CALCULATED_SURVEY_AREA_(ACRES)'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{landArea | number : '1.2-2'}}</label></label>
            </div>
        </div>
        <!-- <div *ngIf="landArea > 0 && (landArea - surveyArea > 0.1*landArea || surveyArea - landArea > 0.1*landArea)" class="p-fluid p-formgrid justify-content-center areaError mb-4" style="display: flex; flex-wrap:wrap">
            <p>{{ "CALCULATED_AREA_IS_MUCH_GREATER_THAN_APPLIED_AREA._PLEASE_RECAPTURE_THE_COORDINATES" | translate }}</p>
        </div> -->
        <!-- <div *ngIf="landArea - surveyArea > 1" class="p-fluid p-formgrid justify-content-center areaError mb-4" style="display: flex; flex-wrap:wrap">
            <p>{{ "CALCULATED_AREA_IS_MUCH_GREATER_THAN_SURVEYED_AREA._PLEASE_RECAPTURE_THE_COORDINATES" | translate }}</p>
        </div> -->
        <!-- Hidden on small screens -->
    </div>

    <div class="card block md:hidden">
        <h5>{{'CAPTURE_IMAGE'| translate}}</h5>
        <!-- <div class="flex flex-wrap justify-content-center">
            <div class="m-2">
                <p-dropdown [options]="uploadOptions" [(ngModel)]="selctedFileType" placeholder="{{'CHOOSE_DOCUMENT_TYPE'| translate}}"
                    optionLabel="name" [showClear]="true"></p-dropdown>
    
            </div>
            <div class="m-2">
                <button (click)="onCaptureImage()" pButton pRipple type="button" label="{{'CAPTURE_IMAGE'| translate}}" [disabled]="!selctedFileType"
                    class="p-button-success mr-2 mb-2"></button>
            </div>
        </div> -->
        <div>
            <div>
                <div>
                    <div class="document-list gap-4" style="display: flex; flex-wrap:wrap;">
                        <div class="document p-fluid p-formgrid grid mt-5"
                            *ngFor="let item of documentList; let i=index">
                            <div>
                                <span style="word-break: break-word;display: flex;
                                justify-content: space-between">
                                    <p style="margin-bottom: 5px;" *ngIf="item.isUploaded" target="_blank">
                                        {{item.name}}
                                    </p>
                                    <p style="margin-bottom: 5px;" *ngIf="!item.isUploaded" target="_blank">
                                        {{item.name}}
                                    </p>
                                    <!-- <i class="pi pi-times cross-icon" (click)="removeImg(i)"></i> -->
                                </span>
                                <img [src]="item.attachmentRawUrl"
                                    style="max-width: 300px; max-height: 300px; display: block; width:200px">
                            </div>
                            <!-- <div class="description">
                                <span>
                                    {{item.displayName}}
                                    <br>
                                    <p style="margin-bottom: 0;" *ngIf="item.isUploaded" target="_blank"> {{item.name}}
                                    </p>
                                    <p style="margin-bottom: 0;" *ngIf="!item.isUploaded" target="_blank"> {{item.name}}
                                    </p>
                                </span>
                            </div> -->
                        </div>
                        <p class="invalid-feedback" *ngIf="documentList && documentList.length<3">
                            {{imageError}}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- <p-dialog [(visible)]="displayCameraComponent" [modal]="true" [maximizable]="true" [draggable]="false"
            [style]="{width: '98vw'}" [resizable]="false" (onHide)="onCloseImageDialog()">
            <div *ngIf="displayCameraComponent">
                <div class="camera-container">
                    <div *ngIf="!imageCaptured">
                        <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="showWebcam"
                            [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
                            [videoOptions]="videoOptions" (cameraSwitched)="cameraWasSwitched($event)"
                            (initError)="handleInitError($event)" class="video-align"></webcam>
                        <br />
                    </div>

                    <h4 *ngIf="errors.length > 0">"{{'MESSAGES'| translate}}":</h4>
                    <ul *ngFor="let error of errors">
                        <li>{{error | json}}</li>
                    </ul>
                </div>
                <div class="webcam-btn" *ngIf="!imageCaptured">
                    <button pButton pRipple type="button" label="{{'CAPTURE'| translate}}" class="p-button-success m-2"
                        (click)="triggerSnapshot()"></button>
                    <button pButton pRipple type="button" label="{{'SWITCH_CAMERA'| translate}}" class="p-button-success m-2"
                        (click)="showNextWebcam(true)"></button>
                </div>
                <div class="snapshot" *ngIf="imageCaptured">
                    <img [src]="webcamImage.imageAsDataUrl" />
                </div>
                <div class="webcam-btn" *ngIf="imageCaptured">
                    <button pButton pRipple type="button" label="{{'UPLOAD'| translate}}" class="p-button-success m-2"
                        (click)="uploadPicture()"></button>
                    <button pButton pRipple type="button" label="{{'RETAKE'| translate}}" class="p-button-success m-2"
                        (click)="retake()"></button>
                </div>
            </div>
        </p-dialog> -->
    </div>


    <div class="card hidden md:block">
        <h5>{{'CAPTURE_IMAGE'| translate}}</h5>
        <!-- <div class="flex flex-wrap justify-content-center">
            <div class="m-2">
                <p-dropdown [options]="uploadOptions" [(ngModel)]="selctedFileType" placeholder="{{'CHOOSE_DOCUMENT_TYPE'| translate}}"
                    optionLabel="name" [showClear]="true"></p-dropdown>
    
            </div>
            <div class="m-2">
                <button (click)="onCaptureImage()" pButton pRipple type="button" label="{{'CAPTURE_IMAGE'| translate}}" [disabled]="!selctedFileType"
                    class="p-button-success mr-2 mb-2"></button>
            </div>
        </div> -->
        <div>
            <div>
                <div>
                    <div class="document-list gap-4" style="display: flex; flex-wrap:wrap;">
                        <div class="document p-fluid p-formgrid grid mt-5"
                            *ngFor="let item of documentList; let i=index">
                            <div>
                                <span style="display: flex; justify-content: space-between">
                                    <!-- {{item.displayName}} -->

                                    <p style="margin-bottom: 5px;" *ngIf="item.isUploaded" target="_blank">
                                        {{item.name}}
                                    </p>
                                    <p style="margin-bottom: 5px;" *ngIf="!item.isUploaded" target="_blank">
                                        {{item.name}}
                                    </p>
                                    <!-- <i class="pi pi-times cross-icon" (click)="removeImg(i)"></i> -->
                                </span>
                                <img [src]="item.attachmentRawUrl"
                                    style="max-width: 300px; max-height: 300px; display: block;">
                            </div>
                            <!-- <div class="description">
                                <span>
                                    {{item.displayName}}
                                    <br>
                                    <p style="margin-bottom: 0;" *ngIf="item.isUploaded" target="_blank"> {{item.name}}
                                    </p>
                                    <p style="margin-bottom: 0;" *ngIf="!item.isUploaded" target="_blank"> {{item.name}}
                                    </p>
                                </span>
                            </div> -->
                        </div>
                        <p class="invalid-feedback" *ngIf="documentList && documentList.length<3">
                            {{imageError}}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- <p-dialog [(visible)]="displayCameraComponent" [modal]="true" [maximizable]="true" [draggable]="false"
            [style]="{width: '98vw'}" [resizable]="false" (onHide)="onCloseImageDialog()">
            <div *ngIf="displayCameraComponent">
                <div class="camera-container">
                    <div *ngIf="!imageCaptured">
                        <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="showWebcam"
                            [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
                            [videoOptions]="videoOptions" (cameraSwitched)="cameraWasSwitched($event)"
                            (initError)="handleInitError($event)"></webcam>
                        <br />
                    </div>

                    <h4 *ngIf="errors.length > 0">"{{'MESSAGES'| translate}}":</h4>
                    <ul *ngFor="let error of errors">
                        <li>{{error | json}}</li>
                    </ul>
                </div>
                <div class="webcam-btn" *ngIf="!imageCaptured">
                    <button pButton pRipple type="button" label="{{'CAPTURE'| translate}}" class="p-button-success m-2"
                        (click)="triggerSnapshot()"></button>
                    <button pButton pRipple type="button" label="{{'SWITCH_CAMERA'| translate}}" class="p-button-success m-2"
                        (click)="showNextWebcam(true)"></button>
                </div>
                <div class="snapshot" *ngIf="imageCaptured">
                    <img [src]="webcamImage.imageAsDataUrl" />
                </div>
                <div class="webcam-btn" *ngIf="imageCaptured">
                    <button pButton pRipple type="button" label="{{'UPLOAD'| translate}}" class="p-button-success m-2"
                        (click)="uploadPicture()"></button>
                    <button pButton pRipple type="button" label="{{'RETAKE'| translate}}" class="p-button-success m-2"
                        (click)="retake()"></button>
                </div>
            </div>
        </p-dialog> -->
    </div>

    <div class="card submit-card mt-2">
        <div class="p-fluid p-formgrid grid">
            <!-- <div class="col-12 md:col-3">
                <p-dropdown [options]="jeList" [(ngModel)]="selectedJE" placeholder="{{ 'Next User'| translate }}"
                    optionLabel="UserID" class="mr-3">
                </p-dropdown>
            </div> -->
            <div class="col-12 md:col-3">
                <p-dropdown [options]="items" [(ngModel)]="selectedStatus"
                    placeholder="{{ 'ACTION_TYPE'| translate }}" optionLabel="status" class="mr-3">
                </p-dropdown>
            </div>
            <div class="col-12 md:col-3">
                <textarea id="description" [(ngModel)]="remarks" placeholder="Remarks" pInputTextarea required
                    rows="3" cols="20" class="mr-3"></textarea>
            </div>
            <div class="col-12 md:col-3">
                <button [disabled]="!selectedStatus" pButton pRipple label="Submit" (click)="onClickSubmit()"
                    class="p-button-success"></button>
            </div>
        </div>
    </div>
</p-dialog>